import { render, staticRenderFns } from "./app-user-ticket.vue?vue&type=template&id=00987f59&"
import script from "./app-user-ticket.vue?vue&type=script&lang=js&"
export * from "./app-user-ticket.vue?vue&type=script&lang=js&"
import style0 from "./app-user-ticket.vue?vue&type=style&index=0&id=00987f59&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports